<template>
  <v-dialog
    persistent
    v-model="get_dialogMain.dialog"
    width="800px"
    justify-center
  >
    <v-toolbar dense dark color="blue darken-2">
      <v-toolbar-title>
        <h3 v-if="get_dialogMain.type == 'create'">Nuevo Colaborador</h3>
        <h3 v-else>Editar Colaborador</h3>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <EmployeeForm :model="employee" :on-success="saveEmployee" :on-cancel="cancel" />
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import EmployeeForm from '@/components/forms/EmployeeForm'
export default {
  data: () => ({
    employee: {}
  }),
  components: {
    EmployeeForm
  },
  methods: {
    ...mapActions(['postEmployees']),
    saveEmployee (model) {
      this.postEmployees(model)
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_employee'])
  },
  watch: {
    get_employee (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Empresa ha sido creado'
      })
      this.cancel()
    }
  }
}
</script>

<style></style>
